<template lang="pug">
div(class="tw-flex-1 tw-h-full tw-overflow-hidden")
  v-fade-transition(mode="out-in")
    router-view
</template>

<style lang="scss"></style>

<script>
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title || 'Kubiqa',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.getters['auth/loggedIn'];
    },
  },
};
</script>
